import "./card.css";
import { Card } from './card';
export default Card;